import React from 'react';
import {AvatarType} from "./AvatarTypes";

const Avatar = (props: AvatarType) => {
	return (
		<div className={`user-avatar ${props.size} ${props.rounded ? 'rounded' : ''}`}>
			<img src='http://placekitten.com/96/96' alt='' />
		</div>
	);
};

export default Avatar;
